<template>
  <!-- 维保阶段 -->
    <div class="bid-box">
        <table class="layui-table">
            <colgroup>
                <col width="150">
                <col width="200">
                <col width="200">
                <col width="120">
                <col>
            </colgroup>
            <thead>
                <tr>
                    <th>序号</th>
                    <th>阶段</th>
                    <th>工程节点</th>
                    <th>文件资料</th>
                    <th>内容</th>
                </tr> 
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td rowspan="2">维保阶段</td>
                    <td>回访表</td>
                    <td style="text-align: left;"></td>
                    <td style="text-align: left;">
                        <div>
                            <div v-for="(item,index) in accept.returnVisit.list" :key="index" style="display:flex;">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess1"
                                    :on-remove="handleDel1"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button size="small" v-if="edit" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>2</td>
                    <!-- <td>维保阶段</td> -->
                    <td>其他</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="accept.otherFile.flag">无</el-checkbox>
                        <el-checkbox v-else disabled  v-model="accept.otherFile.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.otherFile.flag">
                            <div v-for="(item,index) in accept.otherFile.list" :key="index" style="display:flex;margin-bottom:2vh;" @mouseleave="delIndex2='-1'" @mouseenter="delIndex2=index">
                                <el-input v-if="edit" v-model="item.val" placeholder="" style="margin-right:1vw;"></el-input>
                                <el-input v-else  v-model="item.val" placeholder="" style="margin-right:1vw;" disabled></el-input>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess2"
                                    :on-remove="handleDel2"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd2" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex2==index" class="el-icon-delete ctl" @click="delList2(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="edit" style="width:100%;height:8vh;position: relative;position: relative;display: flex;justify-content: center;justify-items: center;align-content: center;align-items: center;">
            <el-button type="primary" @click="onFinalSubmit">保存</el-button>
            <el-button>返回</el-button>
        </div>


        <!-- <el-form ref="form" :model="form" label-width="300px">
            <el-form-item label="所属合同：">
                <span style="color:#296dd3;">{{agreeName}}</span>
            </el-form-item>

            <el-form-item label="月维保监理检查表：">
                <div>
                    <div v-for="(item,index) in accept.monthCheck.list" :key="index" style="display:flex;">
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess"
                            :on-remove="handleDel"
                            :on-preview="showFile"
                            style="margin-left:1vw;"
                            :file-list="item.files">
                            <el-button size="small" v-if="edit" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>

            <el-form-item label="回访表：">
                <div>
                    <div v-for="(item,index) in accept.returnVisit.list" :key="index" style="display:flex;">
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess1"
                            :on-remove="handleDel1"
                            :on-preview="showFile"
                            style="margin-left:1vw;"
                            :file-list="item.files">
                            <el-button size="small" v-if="edit" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>

            <el-form-item label="其他：">
                <el-checkbox v-if="edit" v-model="accept.otherFile.flag">无</el-checkbox>
                <el-checkbox v-else disabled  v-model="accept.otherFile.flag">无</el-checkbox>
                <div v-if="!accept.otherFile.flag">
                    <div v-for="(item,index) in accept.otherFile.list" :key="index" style="display:flex;margin-bottom:2vh;" @mouseleave="delIndex2='-1'" @mouseenter="delIndex2=index">
                        <el-input v-if="edit" v-model="item.val" placeholder="" style="margin-right:1vw;"></el-input>
                        <el-input v-else  v-model="item.val" placeholder="" style="margin-right:1vw;" disabled></el-input>
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess2"
                            :on-remove="handleDel2"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd2" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex2==index" class="el-icon-delete ctl" @click="delList2(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="备注信息：">
                <el-checkbox v-if="edit" v-model="accept.remarks.flag">无</el-checkbox>
                <el-checkbox v-else v-model="accept.remarks.flag" disabled>无</el-checkbox>
                <el-input v-if="!accept.remarks.flag&&edit" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="accept.remarks.val"></el-input>
                <el-input v-if="!accept.remarks.flag&&!edit" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="accept.remarks.val"></el-input>
            </el-form-item>
            <el-form-item v-if="edit">
                <el-button type="primary" @click="onFinalSubmit">保存</el-button>
                <el-button>返回</el-button>
            </el-form-item>
        </el-form> -->
    </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
export default {
    data(){
        return{
            id:"",
            groupId:'',
            agreeName:'',
            uploadUrl:myHttp.uploadFile, //上传地址
            uploadHead:{
                accessToken: util.session.get('token')
            },
            form:{},
            accept:{  //
                monthCheck:{ //月维保监理检查表
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                returnVisit:{ //回访表
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                otherFile:{  //其他
                    flag:false,
                    list:[
                        {index:1,val:'',files:[]},
                    ],
                },
                // remarks:{  //备注
                //     flag:false,
                //     val:''
                // },
            },
            delIndex:'-1',
            delIndex1:'-1',
            delIndex2:'-1',
            status:'',
            unitKind:'',
            edit:''
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        util.session.set('contractId',params.id)
        this.id = params.id
        this.status = params.status
        this.getInfo()
        // this.getData()
        this.edit = util.session.get('principalId')== util.session.get('user').id?true:false
        console.log(this.edit)
    },
    methods:{
        //获取合同信息
        getInfo(){
            var that = this
            myHttp.getContractById({
                id:this.id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proContract
                    that.agreeName = data.entProjectName
                    that.unitKind = data.unitKind
                    that.getData()
                }
            })
        },
        //获取阶段信息
        getData(){
            var that = this
            this.accept = {
                monthCheck:{ //月维保监理检查表
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                returnVisit:{ //回访表
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                otherFile:{  //其他
                    flag:false,
                    list:[
                        {index:1,val:'',files:[]},
                    ],
                },
                remarks:{  //备注
                    flag:false,
                    val:''
                },
            },
            myHttp.getContractStageByProjectId({
                contractId:this.id,
                unitKind:this.unitKind,
                status:this.status,
                flag:'0'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.object
                    if(data){
                        for(var item in that.accept){
                            if(data[item]){
                                var obj = JSON.parse(data[item])
                                if(obj.list.length==0){
                                    that.accept[item].flag = obj.flag
                                }else{
                                    that.accept[item] = obj
                                }
                            }else{
                                that.accept[item].flag = true
                            }
                        }
                    }
                }
            })
        },
        /**月维保监理检查表**************/
        handleSuccess(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.monthCheck.list.length;i++){
                    if(this.accept.monthCheck.list[i].index==other){
                        this.accept.monthCheck.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel(file,fileList){
            for(var i=0;i<this.accept.monthCheck.list.length;i++){
                if(this.accept.monthCheck.list[i].index==file.index){
                    for(var j=0;j<this.accept.monthCheck.list[i].files.length;j++){
                        if(this.accept.monthCheck.list[i].files[j].uid==file.uid){
                            this.accept.monthCheck.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },
        // toAdd(){
        //     var length = this.accept.conproArchive.list.length
        //     var ind = this.accept.conproArchive.list[length-1].index
        //     var obj = {
        //         time:'',files:[],index:parseInt(ind)+1
        //     }
        //     this.accept.conproArchive.list.push(obj)
        // },
        // delList(index){
        //     this.accept.conproArchive.list.splice(index,1)
        //     if(this.accept.conproArchive.list.length==0){
        //         var obj = {
        //             index:1,time:'',files:[]
        //         }
        //         this.accept.conproArchive.list.push(obj)
        //     }
        // },
        
        /** 回访表*/
        handleSuccess1(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.returnVisit.list.length;i++){
                    if(this.accept.returnVisit.list[i].index==other){
                        this.accept.returnVisit.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel1(file,fileList){
            for(var i=0;i<this.accept.returnVisit.list.length;i++){
                if(this.accept.returnVisit.list[i].index==file.index){
                    for(var j=0;j<this.accept.returnVisit.list[i].files.length;j++){
                        if(this.accept.returnVisit.list[i].files[j].uid==file.uid){
                            this.accept.returnVisit.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },
        // toAdd1(){
        //     var length = this.accept.returnVisit.list.length
        //     var ind = this.accept.materialobjectInfo.list[length-1].index
        //     var obj = {
        //         time:'',files:[],index:parseInt(ind)+1
        //     }
        //     this.accept.materialobjectInfo.list.push(obj)
        // },
        // delList1(index){
        //     this.accept.materialobjectInfo.list.splice(index,1)
        //     if(this.accept.materialobjectInfo.list.length==0){
        //         var obj = {
        //             index:1,time:'',files:[]
        //         }
        //         this.accept.materialobjectInfo.list.push(obj)
        //     }
        // },

        /** 国资移交时间及移交表*/
        // handleSuccess2(res, file,opt,other){
        //     if(res.code=='200'){
        //         var obj = {
        //             uid:file.uid,
        //             name:file.name,
        //             url:base.httpCtx+res.data.saveUrls,
        //             baseUrl:res.data.saveUrls,
        //             index:other
        //         }
        //         for(var i=0;i<this.accept.wordTrade.list.length;i++){
        //             if(this.accept.wordTrade.list[i].index==other){
        //                 this.accept.wordTrade.list[i].files.push(obj)
        //             }
        //         }
        //     }else{
        //         this.$message.error(res.msg);
        //     }
        // },
        // handleDel2(file,fileList){
        //     for(var i=0;i<this.accept.wordTrade.list.length;i++){
        //         if(this.accept.wordTrade.list[i].index==file.index){
        //             for(var j=0;j<this.accept.wordTrade.list[i].files.length;j++){
        //                 if(this.accept.wordTrade.list[i].files[j].uid==file.uid){
        //                     this.accept.wordTrade.list[i].files.splice(j,1)
        //                 }
                        
        //             }
        //         }
        //     }
        // },
        // toAdd2(){
        //     var length = this.accept.wordTrade.list.length
        //     var ind = this.accept.wordTrade.list[length-1].index
        //     var obj = {
        //         time:'',files:[],index:parseInt(ind)+1
        //     }
        //     this.accept.wordTrade.list.push(obj)
        // },
        // delList2(index){
        //     this.accept.wordTrade.list.splice(index,1)
        //     if(this.accept.wordTrade.list.length==0){
        //         var obj = {
        //             index:1,time:'',files:[]
        //         }
        //         this.accept.wordTrade.list.push(obj)
        //     }
        // },

        //其他文件上传
        handleSuccess2(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.otherFile.list.length;i++){
                    if(this.accept.otherFile.list[i].index==other){
                        this.accept.otherFile.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel2(file,fileList){
            for(var i=0;i<this.accept.otherFile.list.length;i++){
                if(this.accept.otherFile.list[i].index==file.index){
                    for(var j=0;j<this.accept.otherFile.list[i].files.length;j++){
                        if(this.accept.otherFile.list[i].files[j].uid==file.uid){
                            this.accept.otherFile.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },
        //其他添加列表
        toAdd2(){
            var length = this.accept.otherFile.list.length
            var ind = this.accept.otherFile.list[length-1].index
            var obj = {
                val:'',files:[],index:parseInt(ind)+1
            }
            this.accept.otherFile.list.push(obj)
        },
        delList2(index){
            this.accept.otherFile.list.splice(index,1)
            if(this.final.otherFile.list.length==0){
                var obj = {
                    val:'',files:[],index:1
                }
                this.accept.otherFile.list.push(obj)
            }
        },

        //展示文件
        showFile(file){
            window.open(base.httpCtx+file.baseUrl)
        },

        //提交
        onFinalSubmit(){
            var data = JSON.parse(JSON.stringify(this.accept))
            // for(var item in this.accept){
            //     data[item] = this.accept[item]
            // }
            var columnName = ''
            for(var item in data){
                if(data[item].list && data[item].list.length==1){
                    if((data[item].list[0].val==''||!data[item].list[0].val) && data[item].list[0].files.length==0){
                        data[item].list = []
                    }
                }
                if(!data[item].flag){
                    columnName = columnName==''?item:columnName+','+item
                }
            }
            data['contractId'] = this.id
            var opt = {
                contractId:this.id,
                unitKind:this.unitKind,
                status:this.status,
                flag:'0',
                entity:JSON.stringify(data),
                updateBy:util.session.get('user').id,
                columnName:columnName,
                type:6
            }
            var that = this
            myHttp.createOrupdateContract(opt).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    that.$store.commit('setRefrshAgree',true)
                    that.$message.success('保存成功');
                    that.getData()
                }else{
                    that.$message.error(resp.msg);
                }
            })
        },

    }
}
</script>

<style scoped>
    .bid-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>

<style>
    @import '/layui/css/layui.css';
    .bid-box .el-form-item__content{
        text-align: left;
    }
    .bid-box i.ctl{
        height:40px;
        line-height: 40px;
        margin-left: 0.5vw;
    }
    .bid-box .len100 .el-upload-list__item{
        width: 100%;
    }
    .bid-box .el-form-item__label{
        font-size: 14px;
        font-weight: bold;
        color: #000;
    }
    .bid-box .el-input__prefix{
        height: 40px;
    }
    /* .bid-box .el-upload-list__item-status-label{
        height: 40px;
        line-height: 40px;
    } */
    .layui-table td{
        font-size: inherit;
        text-align: center;
        line-height: 30px;
    }
    .layui-table th{
        font-size: inherit;
        font-weight: bold;
        text-align: center;
    }

    .layui-table td, .layui-table th, .layui-table-col-set, .layui-table-fixed-r, .layui-table-grid-down, .layui-table-header, .layui-table-page, .layui-table-tips-main, .layui-table-tool, .layui-table-total, .layui-table-view, .layui-table[lay-skin=line], .layui-table[lay-skin=row]{
        border-color: #312e2e;
    }
</style>